module.exports = __webpack_public_path__ + "static/media/calendar-white.a787c0d2.svg";